import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { getTageKeyByValue } from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/tage';
import { DataDisplayPlain } from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

export function ExaktValues() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const data = form.state.values;

  return (
    <>
      <DataDisplayPlain
        orientation="horizontal"
        variant="text"
        label={t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.arbeitstage.label',
        )}
        item={data.bezahlung.arbeitszeitkonto.arbeitstage
          .sort((a, b) => a - b)
          .map((arbeitstag, index) => (
            <span
              key={`${arbeitstag}-${index}`}
              className="text-neutrals-900 font-semibold">
              {t(
                'general.date.days.' + getTageKeyByValue(arbeitstag) + 'Short',
              )}
              {'.'}
              {index < data.bezahlung.arbeitszeitkonto.arbeitstage.length - 1 &&
                ', '}
            </span>
          ))}
      />
      <DataDisplayPlain
        orientation="horizontal"
        variant="text"
        label={t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.tagessoll.label',
        )}
        item={
          data.bezahlung.arbeitszeitkonto.tagessoll +
          ' ' +
          t(
            'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.tagessoll.zusammenfassungSuffix',
          )
        }
      />
    </>
  );
}
